module.exports = __webpack_public_path__ + "img/experience07.ddf6005d.jpg";